import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import localStorage from 'redux-persist/lib/storage';
import themeSlice from './slices/themeSlice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage: localStorage,
};
const rootReducer = combineReducers({
  theme: themeSlice,
});

const persistedRootReducer = persistReducer(persistConfig, rootReducer);
export default persistedRootReducer;
